query GetInvestmentPeriods {
  investmentPeriods {
    id
    name
    openingDate
    closingDate
    lockedDate
  }
}
